import React from "react";
import Backdrop from "@mui/material/Backdrop";
import { collection, query, where, getDocs, getFirestore } from "firebase/firestore";
import { useSelector, useDispatch } from "react-redux";
import { getUsersVideos } from "../../services/videosSlice";
import VideoCard from "../../components/video/VideoCard";
import app from "../../services/firebaseinit";
import VideoIframe from "../iframe/VideoIframe";

const db = getFirestore(app);

const videosDb = "videos";

const Videos = () => {
  const [open, setOpen] = React.useState(false);
  const { videos } = useSelector((state) => state.videos);
  const [url, setUrl] = React.useState("");
  const dispatch = useDispatch();
  const getVideos = async () => {
    const videosList = [];
    try {
      const q = query(collection(db, videosDb), where("rejected", "==", false));

      const querySnapshot = await getDocs(q);

      querySnapshot.forEach((doc) => {
        videosList.push(doc.data());
      });
    } catch (error) {
      console.log(error);
    }
    dispatch(getUsersVideos(videosList));
  };
  const setViewUrl = (videourl) => {
    setUrl(videourl);
    setOpen(!open);
  };
  const handleClose = () => {
    setOpen(false);
  };
  React.useEffect(() => {
    getVideos();
  }, [0]);
  return (
    <div className="gradient-bg-welcome">
      <div className="mt-5">
        <div className="portfolioX__portfolioX">
          <div className="portfolioX__portfolioX-container">
            {videos && videos.map((video, i) => (<VideoCard key={i} video={video} onVideoClick={(e) => { e.preventDefault(); setViewUrl(video.videourl); }} />
            ))}
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1, height: 500 }}
              open={open}
              onClick={handleClose}
              className="mt-12"
            >
              <VideoIframe videourl={url} heigh="95" wid="65" />
            </Backdrop>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Videos;
